/* BEGIN-RN-SHIPPING-PILL-JS */
(function() {
  const PILL_SELECTOR = '[data-rn-ship-pill]';
  const INITIALIZED_ATTR = 'data-rn-ship-bound';
  const controllers = new Set();

  function parseJSONAttribute(value) {
    if (value == null || value === '') return '';
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  function parseHolidays(raw) {
    const parsed = parseJSONAttribute(raw);
    if (Array.isArray(parsed)) return parsed;
    return String(parsed || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }

  function coerceNumber(value, fallback) {
    const n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function parseISODate(s) {
    if (!s) return null;
    const parts = String(s).split('-').map(Number);
    if (parts.length < 3 || parts.some((n) => Number.isNaN(n))) return null;
    const [y, m, d] = parts;
    return new Date(Date.UTC(y, m - 1, d, 12, 0, 0));
  }

  function isHoliday(cfg, d) {
    const y = d.getUTCFullYear();
    const m = d.getUTCMonth() + 1;
    const day = d.getUTCDate();
    const iso = `${y}-${String(m).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    return cfg.holidays.includes(iso);
  }

  function isWeekendLocal(d, tz) {
    const wd = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short' }).format(d);
    return wd === 'Sat' || wd === 'Sun';
  }

  function nowInTZ(tz) {
    const now = new Date();
    const dt = new Intl.DateTimeFormat('en-US', {
      timeZone: tz,
      hour: 'numeric',
      hour12: false,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(now);

    const parts = Object.fromEntries(dt.map((part) => [part.type, part.value]));
    const hour = Number(parts.hour || 0);
    const { year, month, day } = parts;
    return { localHour: hour, localNoon: new Date(`${year}-${month}-${day}T12:00:00`) };
  }

  function nextBusinessDay(cfg, d) {
    let t = new Date(d.getTime());
    do {
      t.setUTCDate(t.getUTCDate() + 1);
    } while ((!cfg.weekendFulfillment && isWeekendLocal(t, cfg.tz)) || isHoliday(cfg, t));
    return t;
  }

  function addBusinessDays(cfg, base, days) {
    let t = new Date(base.getTime());
    const total = Math.max(0, Number.isFinite(days) ? Math.floor(days) : 0);
    for (let i = 0; i < total; i += 1) {
      t = nextBusinessDay(cfg, t);
    }
    return t;
  }

  function formatShipDate(cfg, d) {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: cfg.tz,
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    }).format(d);
  }

  function collectPillNodes(root) {
    if (!root) return [];
    const nodes = [];
    if (root.nodeType === 1 && root.matches(PILL_SELECTOR)) {
      nodes.push(root);
    }
    if (root.querySelectorAll) {
      root.querySelectorAll(PILL_SELECTOR).forEach((node) => {
        nodes.push(node);
      });
    }
    return nodes;
  }

  function setupPill(el) {
    const script = el.querySelector('script[data-rn-ship-variants]');
    let variantData = [];
    if (script) {
      try {
        variantData = JSON.parse(script.textContent.trim() || '[]');
      } catch (err) {
        console.error('RN shipping pill: unable to parse variant payload', err);
      }
    }

    const variantMap = variantData.reduce((acc, item) => {
      if (item && item.id != null) {
        acc[item.id] = item;
      }
      return acc;
    }, {});

    const cfg = {
      tz: el.dataset.tz || 'America/Chicago',
      cutoffHour: coerceNumber(el.dataset.cutoff, 17),
      weekendFulfillment: el.dataset.weekend === 'true',
      holidays: parseHolidays(el.dataset.holidays)
    };

    const state = { el, cfg, variantMap };

    function computeShipDate() {
      const preorder = parseISODate(state.el.dataset.preorder);
      const inStock = state.el.dataset.instock === 'true';
      const defaultLead = coerceNumber(state.el.dataset.defaultLead, 0);
      const variantLeadRaw = state.el.dataset.variantLead || String(defaultLead);
      const variantLead = coerceNumber(variantLeadRaw, defaultLead);

      const { localHour, localNoon } = nowInTZ(state.cfg.tz);

      let shipBase = new Date(localNoon.getTime());

      while ((!state.cfg.weekendFulfillment && isWeekendLocal(shipBase, state.cfg.tz)) || isHoliday(state.cfg, shipBase)) {
        shipBase = nextBusinessDay(state.cfg, shipBase);
      }

      if (Number.isFinite(state.cfg.cutoffHour) && localHour >= state.cfg.cutoffHour) {
        shipBase = nextBusinessDay(state.cfg, shipBase);
      }

      if (preorder) return preorder;

      const lead = Math.max(0, variantLead);
      if (!inStock && lead === 0) {
        return nextBusinessDay(state.cfg, shipBase);
      }
      return addBusinessDays(state.cfg, shipBase, lead);
    }

    function render() {
      let formatted;
      let shipDate = null;
      try {
        shipDate = computeShipDate();
        if (!(shipDate instanceof Date) || Number.isNaN(shipDate.getTime())) {
          shipDate = new Date();
        }
        formatted = formatShipDate(state.cfg, shipDate);
      } catch (err) {
        console.error('RN shipping pill render error', err);
        el.dataset.rnShipError = err.message || String(err);
        shipDate = new Date();
        formatted = new Intl.DateTimeFormat('en-US', {
          weekday: 'short',
          month: 'short',
          day: 'numeric'
        }).format(shipDate);
      }

      const textEl = state.el.querySelector('.rn-ship-text');
      if (!textEl) return;
      const dateEl = textEl.querySelector('.rn-ship-date');
      if (dateEl) {
        dateEl.textContent = formatted;
      } else {
        textEl.textContent = `Ships by ${formatted}`;
      }
    }

    function updateFromVariant(variant) {
      if (!variant) return;
      const variantInfo = state.variantMap[variant.id];
      if (variantInfo) {
        const fallbackLead = state.el.dataset.defaultLead || '0';
        const leadValue = variantInfo.lead != null ? variantInfo.lead : fallbackLead;
        state.el.dataset.variantLead = String(leadValue);
        state.el.dataset.preorder = variantInfo.preorder || '';
        state.el.dataset.instock = variantInfo.available ? 'true' : 'false';
      } else {
        state.el.dataset.variantLead = state.el.dataset.defaultLead || '0';
        if (typeof variant.available === 'boolean') {
          state.el.dataset.instock = variant.available ? 'true' : 'false';
        }
        if (!variant.preorder) {
          state.el.dataset.preorder = '';
        }
      }
      state.el.dataset.variantId = String(variant.id);
      render();
    }

    render();

    return {
      state,
      render,
      updateFromVariant
    };
  }

  function init(root) {
    collectPillNodes(root || document).forEach((el) => {
      if (el.hasAttribute(INITIALIZED_ATTR)) return;
      el.setAttribute(INITIALIZED_ATTR, 'true');
      const controller = setupPill(el);
      if (controller) {
        controllers.add(controller);
      }
    });
  }

  function cleanup() {
    controllers.forEach((controller) => {
      if (!document.contains(controller.state.el)) {
        controllers.delete(controller);
      }
    });
  }

  function normalizeVariant(variant) {
    if (!variant) return null;
    if (typeof variant === 'object' && 'id' in variant) {
      return variant;
    }
    const id = typeof variant === 'string' ? Number(variant) : variant;
    if (!id) return null;
    return { id };
  }

  function handleVariantEvent(event) {
    cleanup();
    const rawVariant = event && event.detail && (event.detail.variant || event.detail.selectedVariant || event.detail.productVariant);
    const variant = normalizeVariant(rawVariant);
    if (!variant) return;
    controllers.forEach((controller) => controller.updateFromVariant(variant));
  }

  function handleFormChange(event) {
    cleanup();
    if (!event.target) return;
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;

    const variantId = Number(form.querySelector('[name="id"]')?.value);
    if (!variantId) return;

    const variant = { id: variantId };
    controllers.forEach((controller) => controller.updateFromVariant(variant));
  }

  init(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  }

  document.addEventListener('shopify:section:load', (event) => {
    cleanup();
    init(event.target);
    controllers.forEach((controller) => controller.render());
  });
  document.addEventListener('shopify:section:unload', cleanup);
  document.addEventListener('shopify:section:reorder', () => {
    cleanup();
    init(document);
  });
  document.addEventListener('shopify:block:select', (event) => {
    cleanup();
    init(event.target);
    controllers.forEach((controller) => controller.render());
  });
  document.addEventListener('shopify:block:deselect', (event) => {
    cleanup();
    init(event.target);
    controllers.forEach((controller) => controller.render());
  });

  document.addEventListener('variant:change', handleVariantEvent);
  document.addEventListener('variant:changed', handleVariantEvent);
  document.addEventListener('product:variant-change', handleVariantEvent);
  document.addEventListener('change', handleFormChange);
})();
/* END-RN-SHIPPING-PILL-JS */
